import React, {Fragment} from 'react';

import {Link} from 'react-router';

import {InlineExclusiveGatewayIcon} from 'app/procedures/components/step-types-icons';
import {getContentType} from 'app/utils/content-type';
import {getObjectName} from 'app/utils/fallbacks';

import type {ContentType} from 'sweet-types';

type Item = {
  readonly html_url: string;
  readonly name: string;
};

type Props = {
  contentType: ContentType;
  items: Array<Item>;
};

export const ItemRelationsListOfGenerics = ({items, contentType}: Props) =>
  items != null && items.length > 0 ? (
    <Fragment>
      {items.map((item) => (
        <Link
          key={item.html_url || item.name}
          className="badge badge-light mr-1"
          to={item.html_url}
        >
          {contentType === 'decision' ? (
            <InlineExclusiveGatewayIcon />
          ) : (
            <i
              className={`fa fa-fw ${getContentType(contentType).icon} mr-1`}
            />
          )}
          {getObjectName(item, contentType, true)}
        </Link>
      ))}
    </Fragment>
  ) : null;
